import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';

import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { makePath } from 'helpers/link-generation';

import { trackNoSchedulesIntegrationsLinkClicked } from './ScheduleListV2.analytics';
import messages from './ScheduleListV2EmptyState.messages';

const { element } = bem('schedule-list-v2-empty-state');

const ScheduleListV2IntegrationsUpsell = ({ venueId }) => (
  <div className={element('upsell')}>
    <Isvg className={element('upsell-icon')} src={ICONS.announcement} />
    <div className={element('upsell-text')}>
      <Message as="p" className={element('upsell-title')} message={messages.integrationsUpsellTitle} />
      <Message
        as="p"
        className={element('upsell-subtitle')}
        message={messages.integrationsUpsellSubtitle}
        values={{
          link: text => (
            <Link
              className={element('upsell-link')}
              onClick={() => trackNoSchedulesIntegrationsLinkClicked({ venueId })}
              to={makePath.integrations(venueId)}>
              {text}
            </Link>
          ),
        }}
      />
    </div>
  </div>
);

ScheduleListV2IntegrationsUpsell.propTypes = {
  venueId: PropTypes.number.isRequired,
};

export default ScheduleListV2IntegrationsUpsell;
